import { ShoppingCartThemeSizeConfig } from './types';

const small: ShoppingCartThemeSizeConfig = {
  shoppingCart: {},
};

export default small;
